export default __webpack_public_path__ + "media/images/computer-man-2-bd316e82b21ab32f95245fd96cc567ed.png";